<button matButton="text" type="button" [matMenuTriggerFor]="actionMenu" class="mom-danger">
    <mat-icon>arrow_drop_down</mat-icon>
    Actions
</button>
<mat-menu #actionMenu="matMenu">
    <ng-container *ngTemplateOutlet="menuItems; context: { $implicit: items() }"></ng-container>
</mat-menu>
<ng-template #menuItems let-items>
    @for (item of items; track $index) {
        <button mat-menu-item (click)="doActionType(item.action, item.route)">
            <mat-icon>{{ item.icon }}</mat-icon>
            <span>{{ setActionTitle(item) }}</span>
        </button>
    }
    <!-- <div>
        {{actionData().id}}
    </div> -->
</ng-template>
